var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellRinging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.46265C10 4.35808 10.8954 3.46265 12 3.46265C13.1046 3.46265 14 4.35808 14 5.46265C16.3402 6.5692 17.8786 8.87689 18 11.4626V14.4626C18.1526 15.7234 18.8949 16.8368 20 17.4626H4C5.10511 16.8368 5.84739 15.7234 6 14.4626V11.4626C6.12137 8.87689 7.65983 6.5692 10 5.46265",
    stroke: "#F6F6F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.4626V18.4626C9 20.1195 10.3431 21.4626 12 21.4626C13.6569 21.4626 15 20.1195 15 18.4626V17.4626",
    stroke: "#F6F6F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 7.18965C20.3441 5.7629 19.3916 4.49234 18.2061 3.46265",
    stroke: "#D02B20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.18965C3.65535 5.76309 4.60715 4.49254 5.792 3.46265",
    stroke: "#D02B20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRinging);
export default __webpack_public_path__ + "static/media/bell-ringing.01e840ffef40716af127db476ab4b121.svg";
export { ForwardRef as ReactComponent };